import { render } from "./BranchEmployees.vue?vue&type=template&id=dc452bc8"
import script from "./BranchEmployees.vue?vue&type=script&lang=js"
export * from "./BranchEmployees.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Evuri\\New Owners\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__